import React, { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { countryFieldSelector } from 'app/selectors/countryFieldSelector';
import { sortAlphabetically } from 'utils/sort';
import { getCountries } from 'app/actions/formActions';
import { useMountEffect } from 'hooks/useMountEffect';
import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';
import Placeholder from 'forms/consumer/components/Placeholder';

export const CountryField = ({
	value,
	onChange,
	required,
	label,
	name,
	error,
	disabled,
	...restProps
}) => {
	const dispatch = useAppDispatch();
	const requested = useAppSelector((state) => state.countries.requested);
	const countries = useAppSelector(countryFieldSelector) as {
		[key: number]: string;
	};

	useMountEffect(() => {
		if (!requested) {
			dispatch(getCountries());
		}
	});

	const handleChange = (v) => {
		onChange(parseInt(v[0]));
	};

	const countryList = useMemo(() => sortAlphabetically(countries), [countries]);
	const countryMap = useMemo(
		() => new Map(Object.entries(countries)),
		[countries],
	);

	const dataProps = {};
	Object.keys(restProps)
		.filter((attr) => attr.startsWith('data-'))
		.forEach((attr) => (dataProps[attr] = restProps[attr]));

	if (countryList.length === 0) {
		return (
			<FormControl fullWidth>
				<FormLabel>{label}</FormLabel>
				<Placeholder fieldType="profile" animate />
			</FormControl>
		);
	}

	return (
		<FormControl fullWidth required={required}>
			<FormLabel id={`${name}-label`}>{label}</FormLabel>
			<Autocomplete
				disableClearable
				// @ts-expect-error TS(2322): Type '{ disableClearable: true; required: any; nam... Remove this comment to see the full error message
				name={name}
				disablePortal
				aria-labelledby={`${name}-label`}
				size="small"
				options={countryList}
				disabled={disabled}
				getOptionLabel={(o) => {
					return typeof o === 'number' ? countryMap.get(`${o}`) : o[1];
				}}
				isOptionEqualToValue={(o, v) => {
					return parseInt(o[0]) === v;
				}}
				value={value || null}
				renderInput={(params) => {
					const paramsAndProps = {
						...params,
						inputProps: { ...params.inputProps, ...dataProps },
					};
					return (
						<TextField
							{...paramsAndProps}
							required={required}
							error={Boolean(error)}
							placeholder="Select country"
						/>
					);
				}}
				renderTags={() => <></>}
				onChange={(_, values) => handleChange(values)}
			/>
		</FormControl>
	);
};
